var map = {
	"./mobile/guestType1BgBorder.png": 9002,
	"./mobileBlack/guestType1BgBorder.png": 4817,
	"./pc/guestType1BgBorder.png": 2664,
	"./pcBlack/guestType1BgBorder.png": 1313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7327;